module.exports = __webpack_public_path__ + "assets/img/media_23.ddbf7790.png";